import { UnitEventsPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/events/Index'

export const UnitEvents = () => <UnitEventsPage />
